import React from 'react';
import { bool, shape, string } from 'prop-types';

const UnblockColor = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.8325 5.58336L1.5 3.25086L2.5575 2.19336L15.1125 14.7484L14.055 15.8059L11.0475 12.7984H9.75V11.5009L8.0475 9.79836H6V8.29836H6.5475L4.995 6.74586C3.8325 6.87336 2.925 7.85586 2.925 9.04836C2.925 10.3309 3.9675 11.3734 5.25 11.3734H8.25V12.7984H5.25C3.18 12.7984 1.5 11.1184 1.5 9.04836C1.5 7.48086 2.4675 6.13836 3.8325 5.58336ZM12.75 5.29836H9.75V6.72336H12.75C14.0325 6.72336 15.075 7.76586 15.075 9.04836C15.075 10.0009 14.4975 10.8259 13.6725 11.1784L14.7225 12.2284C15.7875 11.5684 16.5 10.3909 16.5 9.04836C16.5 6.97836 14.82 5.29836 12.75 5.29836ZM10.7925 8.29836L12 9.50586V8.29836H10.7925Z" fill="currentColor" />
  </svg>
);

UnblockColor.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default UnblockColor;
